export const SEARCH_DESKTOP_BREAKPOINT = 500
